import type { TOC } from '@ember/component/template-only';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import dateFormat from 'garaje/helpers/date-format';
import type Entry from 'garaje/models/entry';
import type Invite from 'garaje/models/invite';

interface ConnectNotificationActivitySignature {
  Args: {
    model: Entry | Invite;
    showTime?: boolean;
  };
  Element: HTMLSpanElement;
}

export default <template>
  <span class="inline-flex items-center" data-test-connect-notification-activity ...attributes>
    {{svgJar
      (if @model.latestNotificationLog "checkmark-gray" "gray-dash-small")
      class=(if @model.latestNotificationLog "mr-2 -m-1" "mr-3")
      width=(unless @model.latestNotificationLog "8px")
    }}
    {{#if @model.latestNotificationLog}}
      Sent
      {{#if @showTime}}
        at
        {{dateFormat @model.latestNotificationLog.createdAt "h:mm aaa"}}
      {{/if}}
    {{else}}
      Not sent
    {{/if}}
  </span>
</template> satisfies TOC<ConnectNotificationActivitySignature>;
